import { setOrderFormError, clearOrderFormError, reverseGeocodeLocation, updateOrderFormField } from '../redux_files/actions/orderFormActions';
import { showLoader, hideLoader } from '../redux_files/actions/loaderActions';
import { PANIPAT_BOUNDS, FREE_DELIVERY_RADIUS_KM, MAX_DELIVERY_RADIUS_KM } from './locationConstants';
import {CHOOSE_MENU_CONTEXT} from '../utils/constants.js';
import { getLocationFromCoords } from '../components/location/location_actions.js'; 
import { round2Decimal } from './common.js';

export const isWithinPanipat = (location) => {
  return (
    location.lat >= PANIPAT_BOUNDS.minLat &&
    location.lat <= PANIPAT_BOUNDS.maxLat &&
    location.lng >= PANIPAT_BOUNDS.minLng &&
    location.lng <= PANIPAT_BOUNDS.maxLng
  );
};
export const calculatePriceForCustomMenu = (deliveryDistance, orderTotal, freeRadiusKm = FREE_DELIVERY_RADIUS_KM) => {
  const minOrderValue = 150;
  let deliveryInfo = {
    available: false,
    minOrder: undefined,
    deliveryCharge: undefined,
    extraFreeKm: 0,
    chargeableDistance: 0,
    addForFullFreeDelivery: 0,
    message: '',
    error: false,
    deliveryDistance
  };

  // Case 1: order value < 150, no delivery
  if (orderTotal < 150) {
    deliveryInfo.available = false;
    deliveryInfo.message = `Min Order value ₹${minOrderValue}`;
    deliveryInfo.error = true;
    return deliveryInfo;
  }

  // Case 2: distance <= freeRadiusKm, min order {minOrderValue}, free delivery
  if (deliveryDistance <= freeRadiusKm && orderTotal >= minOrderValue) {
    deliveryInfo.available = true;
    deliveryInfo.minOrder = minOrderValue;
    deliveryInfo.deliveryCharge = 0;
    deliveryInfo.error = false;
    deliveryInfo.message = "Free delivery!";
    return deliveryInfo;
  }
  // // Case 3: distance between 0km to 5km, orderTotal between 150 to 249, Rs 50/km delivery charge
  // if (deliveryDistance >= 0 && deliveryDistance <= 5 && orderTotal >= 150 && orderTotal < 250) {
  //   deliveryInfo.available = true;
  //   deliveryInfo.minOrder = orderTotal;
  //   deliveryInfo.deliveryCharge = 50 * deliveryDistance;
  //   deliveryInfo.message = `Minimum order value of ₹250!`;
  //   deliveryInfo.error = true;
  //   return deliveryInfo;
  // }
  // Case 4: distance between freeRadiusKm to 15km, min order minOrderValue + Rs 50/km or Rs 15/km delivery charge
  // if (deliveryDistance > freeRadiusKm && deliveryDistance <= 15 && orderTotal >= minOrderValue) {
  if (deliveryDistance > freeRadiusKm && deliveryDistance <= MAX_DELIVERY_RADIUS_KM) {
    const applicableDistanceForCharge = deliveryDistance - freeRadiusKm;
    // Calculate extra free km for every Rs 50 above minOrderValue
    const extraFreeKm = Math.floor((orderTotal - minOrderValue) / 50);
    const chargeableDistance = Math.max(0, applicableDistanceForCharge - extraFreeKm);
    // Option 1: min order increases by Rs 50 per km above freeRadiusKm
    const minOrder = minOrderValue + 50 * applicableDistanceForCharge;
    // Option 2: delivery charge increases by Rs 15 per chargeable km
    const deliveryCharge = 15 * chargeableDistance;
    // Calculate how much more user needs to add for full free delivery
    let addForFullFreeDelivery = 0;
    if (chargeableDistance > 0) {
      addForFullFreeDelivery = chargeableDistance * 50;
    }
    deliveryInfo.available = true;
    deliveryInfo.minOrder = minOrder;
    deliveryInfo.deliveryCharge = deliveryCharge;
    deliveryInfo.extraFreeKm = extraFreeKm;
    deliveryInfo.chargeableDistance = chargeableDistance;
    deliveryInfo.addForFullFreeDelivery = addForFullFreeDelivery;
    if (chargeableDistance === 0) {
      deliveryInfo.error = false;
      deliveryInfo.message = "Free delivery!";
    } else {
      deliveryInfo.error = true;
      deliveryInfo.message = `Add items worth ₹${round2Decimal(addForFullFreeDelivery)} for free delivery!`;
    }
    return deliveryInfo;
  }

  // // Case 5: distance > 15km, min order 700, delivery charge 150
  // if (deliveryDistance > 15 && orderTotal >= 700) {
  //   deliveryInfo.available = true;
  //   deliveryInfo.minOrder = 700;
  //   deliveryInfo.deliveryCharge = 150;
  //   deliveryInfo.error = false;
  //   deliveryInfo.message = "Delivery available";
  //   return deliveryInfo;
  // }

  // If none of the cases match, delivery is not available
  deliveryInfo.available = false;
  deliveryInfo.message = "Unable to deliver to this location. Please contact us for more details.";
  deliveryInfo.error = true;
  deliveryInfo.deliveryCharge = undefined;
  return deliveryInfo;
}

export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

export const calculatePrice = (plateSize, numberOfPlates, deliveryDistance, freeRadiusKm = FREE_DELIVERY_RADIUS_KM) => {
  const plates = numberOfPlates === '' ? 0 : Number(numberOfPlates);
  let platePrice = 0;
  let deliveryCharge = 0;

  if (plateSize === 'half') {
    platePrice = 50;
  } else {
    if (plates > 15) platePrice = 55;
    else if (plates > 6) platePrice = 60;
    else platePrice = 70;
  }

  if (deliveryDistance !== null && deliveryDistance !== undefined) {
    if (deliveryDistance <= freeRadiusKm) {
      deliveryCharge = 0;
    } else if (plates >= 2) {
      deliveryCharge = 0;
    } else if (plates === 1) {
      const chargeableDistance = deliveryDistance - freeRadiusKm;
      deliveryCharge = Math.ceil(chargeableDistance) * 5;
    }
  }

  const subtotal = platePrice * plates;
  const total = subtotal + deliveryCharge;

  return { platePrice, subtotal, deliveryCharge, total, distance: deliveryDistance };
};

export const handleUseCurrentLocation = (dispatch, DELIVERY_CENTER, SCREEN_CONTEXT, onResult) => {
  const customOrderScreen = SCREEN_CONTEXT === CHOOSE_MENU_CONTEXT;
  if (!navigator.geolocation) {
    if(customOrderScreen) {
      onResult && onResult({ "locationError": "Geolocation is not supported on this device." });
      return;
    } else {
      dispatch(setOrderFormError('currentLocation', 'Geolocation is not supported on this device.'));
      return;
    }
  }
   if(!customOrderScreen) {
    dispatch(showLoader());
    dispatch(updateOrderFormField('currentLocationLoading', true));
    dispatch(clearOrderFormError('currentLocation'));
   }

  navigator.geolocation.getCurrentPosition(
    (position) => {
      const location = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };

      // Check if current location is within Panipat
      if (!isWithinPanipat(location)) {
        // Still show the location but display error
        const address = `Lat: ${location.lat.toFixed(4)}, Lng: ${location.lng.toFixed(4)}`;
        const distance = calculateDistance(DELIVERY_CENTER.lat, DELIVERY_CENTER.lng, location.lat, location.lng);
        if(customOrderScreen) {
          onResult && onResult({ "locationError": "❌ Your current location is outside Panipat. Delivery is not available for this location." });
          return;
        } else {
          dispatch(updateOrderFormField('deliveryLocation', address));
          dispatch(updateOrderFormField('selectedDeliveryCoords', location));
          dispatch(updateOrderFormField('deliveryDistance', distance));
          dispatch(setOrderFormError('currentLocation', `❌ Your current location is outside Panipat. Delivery is not available for this location. Please select a location within Panipat using the map or search.`));
          dispatch(updateOrderFormField('currentLocationLoading', false));
          dispatch(hideLoader());
        }
        return;
      }

      // Location is within Panipat - proceed normally
      // Dispatch saga action to reverse geocode
      if(customOrderScreen) {
        dispatch(getLocationFromCoords(location.lat, location.lng));
      } else {
        dispatch(reverseGeocodeLocation(location.lat, location.lng));
      }

      // Update coordinates and distance
      const distance = calculateDistance(DELIVERY_CENTER.lat, DELIVERY_CENTER.lng, location.lat, location.lng);
      if(customOrderScreen) {
         onResult && onResult({
          deliveryDistance: distance,
          selectedDeliveryCoords: location
        });
        return;
      } else {
        dispatch(updateOrderFormField('selectedDeliveryCoords', location));
        dispatch(updateOrderFormField('deliveryDistance', distance));
        dispatch(clearOrderFormError('currentLocation'));
        dispatch(updateOrderFormField('currentLocationLoading', false));
        // Loader will be hidden by the saga after reverse geocoding completes
      }
     
    },
    (error) => {
      const errorMessages = {
          [error.PERMISSION_DENIED]: 'Location permission denied. Please allow location access in your browser settings.',
          [error.POSITION_UNAVAILABLE]: 'Location information is unavailable. Please try again or use "Select Custom Location".',
          [error.TIMEOUT]: 'Location request timed out. Please try again.'
        };
       if(customOrderScreen) {
        onResult && onResult({ "locationError": errorMessages[error.code] || 'Unable to retrieve your location. Please try again or use "Select Custom Location".' });
        return;
       } else {
        dispatch(updateOrderFormField('currentLocationLoading', false));
        dispatch(hideLoader());
        
        const message = errorMessages[error.code] || 'Unable to retrieve your location. Please try again or use "Select Custom Location".';
        dispatch(setOrderFormError('currentLocation', message));
      }
    },
    { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
  );
};
export const calculatePriceForCustomMenuWithTaxes = (deliveryDistance, orderTotal, freeRadiusKm = FREE_DELIVERY_RADIUS_KM) => {
  const minOrderValue = 150;
  let deliveryInfo = {
    available: false,
    minOrder: undefined,
    deliveryCharge: undefined,
    extraFreeKm: 0,
    chargeableDistance: 0,
    addForFullFreeDelivery: 0,
    message: '',
    error: false,
    deliveryDistance
  };

  // Case 1: order value < minOrderValue, no delivery
  if (orderTotal < minOrderValue) {
    deliveryInfo.available = false;
    deliveryInfo.message = `Min Order value ₹${minOrderValue}`;
    deliveryInfo.error = true;
    return deliveryInfo;
  }

  // Case 2: distance <= freeRadiusKm, min order {minOrderValue}, free delivery
  if (deliveryDistance <= freeRadiusKm && orderTotal >= minOrderValue) {
    deliveryInfo.available = true;
    deliveryInfo.minOrder = minOrderValue;
    deliveryInfo.deliveryCharge = 0;
    deliveryInfo.error = false;
    deliveryInfo.message = "Free delivery!";
    return deliveryInfo;
  }
  // Case 3: distance between 0km to 5km, orderTotal between 150 to 249, Rs 50/km delivery charge
  // if (deliveryDistance >= 0 && deliveryDistance <= 5 && orderTotal >= 150 && orderTotal < 250) {
  //   deliveryInfo.available = true;
  //   deliveryInfo.minOrder = orderTotal;
  //   deliveryInfo.deliveryCharge = 50 * deliveryDistance;
  //   deliveryInfo.message = `Minimum order value of ₹250!`;
  //   deliveryInfo.error = true;
  //   return deliveryInfo;
  // }
  // Case 4: distance between freeRadiusKm to 15km, min order 250 + Rs 50/km or Rs 10/km delivery charge
  // if (deliveryDistance > freeRadiusKm && deliveryDistance <= 15 && orderTotal >= minOrderValue) {
  if (deliveryDistance > freeRadiusKm && deliveryDistance <= 15) {
    const applicableDistanceForCharge = deliveryDistance - freeRadiusKm;
    // Calculate extra free km for every Rs 50 above minOrderValue
    const extraFreeKm = Math.floor((orderTotal - minOrderValue) / 50);
    const chargeableDistance = Math.max(0, applicableDistanceForCharge - extraFreeKm);
    // Option 1: min order increases by Rs 50 per km above freeRadiusKm
    const minOrder = minOrderValue + 50 * applicableDistanceForCharge;
    // Option 2: delivery charge increases by Rs 10 per chargeable km
    const deliveryCharge = 10 * chargeableDistance;
    // Calculate how much more user needs to add for full free delivery
    let addForFullFreeDelivery = 0;
    if (chargeableDistance > 0) {
      addForFullFreeDelivery = chargeableDistance * 50;
    }
    deliveryInfo.available = true;
    deliveryInfo.minOrder = minOrder;
    deliveryInfo.deliveryCharge = deliveryCharge;
    deliveryInfo.extraFreeKm = extraFreeKm;
    deliveryInfo.chargeableDistance = chargeableDistance;
    deliveryInfo.addForFullFreeDelivery = addForFullFreeDelivery;
    if (chargeableDistance === 0) {
      deliveryInfo.error = false;
      deliveryInfo.message = "Free delivery!";
    } else {
      deliveryInfo.error = true;
      deliveryInfo.message = `Add items worth ₹${round2Decimal(addForFullFreeDelivery)} for free delivery!`;
    }
    return deliveryInfo;
  }

  // Case 5: distance > 15km, min order 700, delivery charge 150
  if (deliveryDistance > 15 && orderTotal >= 700) {
    deliveryInfo.available = true;
    deliveryInfo.minOrder = 700;
    deliveryInfo.deliveryCharge = 150;
    deliveryInfo.error = false;
    deliveryInfo.message = "Delivery available";
    return deliveryInfo;
  }

  // If none of the cases match, delivery is not available
  deliveryInfo.available = false;
  deliveryInfo.message = "Unable to deliver to this location. Please contact us for more details.";
  deliveryInfo.error = true;
  deliveryInfo.deliveryCharge = undefined;
  return deliveryInfo;
}
